import { clamp } from 'lodash';
import { AppThunk } from '../../../store/rootReducer';
import * as navigationActions from '../actions/navigation.actions';
import {
  maxTimestampSelector,
  minTimestampSelector,
  timestampSelector,
} from '../selectors/navigation.selectors';

export const navigateBy = (difference: number): AppThunk => async (
  dispatch,
  getState,
) => {
  const timestamp = timestampSelector(getState());
  const min = minTimestampSelector(getState());
  const max = maxTimestampSelector(getState());

  const newTimestamp = clamp(timestamp - difference, min, max);

  if (newTimestamp === timestamp) {
    return;
  }

  dispatch(
    navigationActions.setTimestamp({
      timestamp: newTimestamp,
      meta: { history: false },
    }),
  );
};
